import { RootState } from '@/modules/ewwms/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';

export type Getters = {
  bestand(state: State): Array<Listeartikel>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  bestand(state) {
    return state.bestand;
  },
};
